/**
 * User layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { authenticatedPageDecorator } from 'Decorators';
import Tabs from 'Components/Tabs';
import Header from 'Components/Header';
import UserEdit from './containers/UserEdit';
import UserRolesList from './containers/UserRolesList';
import UserSubmissionsList from './containers/UserSubmissionsList';
import Grid from '@material-ui/core/Grid';

import { ROLE_ADMIN } from 'Constants';

@authenticatedPageDecorator([ROLE_ADMIN])
export default class User extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        match: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
    };

    tabs = [
        {
            name: 'general',
            text: 'user.tab.general',
        },
        {
            name: 'roles',
            text: 'user.tab.roles',
        },
        {
            name: 'submissions',
            text: 'user.tab.submissions',
        },
    ];

    handleClick = tab => {
        const {
            history,
            match: { params },
        } = this.props;

        history.push(`/users/${params.id}/${tab}`);
    };

    getActiveTab = () => {
        const { match } = this.props;

        return match.params && match.params.tab ? match.params.tab : 'general';
    };

    renderTab = () => {
        const { match } = this.props;

        switch (this.getActiveTab()) {
            case 'roles':
                return <UserRolesList match={match} />;
            case 'submissions':
                return <UserSubmissionsList match={match} />;
            default:
                return <UserEdit match={match} />;
        }
    };

    render() {
        return (
            <div className="wrapJournalList">
                <Header title="title.users.edit" />

                <Grid container spacing={24}>
                    <Grid item xs={10}>
                        <div>{this.renderTab()} </div>
                    </Grid>
                    <Grid item xs={2}>
                        <Tabs tabs={this.tabs} active={this.getActiveTab()} handleClick={this.handleClick} />
                    </Grid>
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/UserEdit/UserEdit.jsx